import React , {useState} from 'react'
import DevelopersPageComponent from "../topDevelopersComponents/developerspageComponent/developersPageComponent";

import { groupProperties } from "../topDevelopersComponents/filterproperty";

const SimilarProject = ({Similarprojects}) => {
  const isState = 1; // Change to 0 if you want to group by location instead of state

  // Safeguard: Ensure developers.properties is an array
  const properties = Similarprojects?.properties || [];
  const [flag, setFlag] = React.useState(true);
  // Group properties based on isState flag
  const groupedProperties = groupProperties(properties, isState);
  return (
    <div>
      {/* Render properties based on grouping condition */}
      {/* const flag = true; // Or false, depending on your logic */}
      <div className="">
        {Object.entries(groupedProperties).map(([key, properties]) => (
          <div key={key}>
            <DevelopersPageComponent
              developersData={properties}
              heading={
                flag
                  ? `Similar Projects`
                  : `${properties[0]?.developer} Properties in ${key}`
              }
               color="white"
               textcolor="#374151"
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default SimilarProject;
